import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshToken, fetchUserData, clearUser, selectUser } from '../features/auth/authSlice';

export function useAuth() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let intervalId;

    const refreshTokenAndFetchUser = async () => {
      try {
        if (user && user.token) {
          await dispatch(refreshToken()).unwrap();
          await dispatch(fetchUserData()).unwrap();
          console.log('Token refreshed and user data fetched successfully');
        }
      } catch (error) {
        console.error('Error refreshing token or fetching user data:', error);
        dispatch(clearUser());
      }
    };

    const initializeAuth = async () => {
      if (user && !isInitialized) {
        await refreshTokenAndFetchUser();
        setIsInitialized(true);
        
        // Set up interval for token refresh
        intervalId = setInterval(refreshTokenAndFetchUser, 55 * 60 * 1000); // Refresh every 55 minutes
      }
    };

    initializeAuth();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch, user, isInitialized]);

  return user;
}
